import { gsap, ScrollTrigger } from "../layout"
import Collapse from 'bootstrap/js/dist/collapse';

// custom library
import Masonry from "masonry-layout"
import InfiniteScroll from "infinite-scroll"
import { Fancybox } from "@fancyapps/ui";

let msnry

function initFancyBox() {
    Fancybox.bind("[data-fancybox]", {
        // hideScrollbar: false,
    });
}

function accordionImageChange() {
    const qualityAccordion = document.querySelector('#accordionQuality')
    const qualityImage = document.querySelector('#quality-image-desktop img')
    const firstImage = document.querySelector('.custom-accordion__item').dataset.image

    // set initial image
    qualityImage.setAttribute('src', firstImage)

    // change image when accordion showed
    qualityAccordion.addEventListener('show.bs.collapse', (e) => {
        const selectedAccordion = e.target.parentElement
        const image = selectedAccordion.dataset.image

        gsap.timeline({ 
            defaults: { 
                duration: 0.3,
            } 
        })
            .to('#quality-image-desktop', {
                autoAlpha: 0,
                onComplete: () => {
                    qualityImage.setAttribute('src', image)
                }
            })
            .to('#quality-image-desktop', {
                autoAlpha: 1
            })
    })
}

function galleryMasonry() {

    if (window.innerWidth <= 767) {
        msnry = new Masonry( '.gallery__grid', {
            itemSelector: '.gallery__grid-item',
            columnWidth: 0,
            percentPosition: true,
            gutter: 10,
        });
    } else {
        msnry = new Masonry( '.gallery__grid', {
            itemSelector: '.gallery__grid-item',
            columnWidth: 0,
            percentPosition: true,
            gutter: 30,
        });
    }

    ScrollTrigger.refresh()
}

function galleryFade() {
    const allGallery = document.querySelectorAll('.gallery__grid-item')

    allGallery.forEach(ag => {
        gsap.to(ag, {
            autoAlpha: 1,
            duration: 1,
            delay: 0.4,
            scrollTrigger: {
                trigger: ag,
                start: 'top bottom',
            }
        })
    });
}

document.addEventListener('DOMContentLoaded', () => {
    initFancyBox()
    accordionImageChange()
    galleryFade()
})

window.addEventListener('load', () => {
    // seeMoreGallery()
    galleryMasonry()
})
